import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { usePricing } from '../hooks/usePricing';

/** Barra inferior en mobile: aparece al salir del hero y se oculta en las secciones de compra. */
export function StickyMobileCTA() {
  const [heroVisible, setHeroVisible] = useState(true);
  const [buyVisible, setBuyVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const {
    price
  } = usePricing();
  useEffect(() => {
    const hero = document.getElementById('inicio');
    const buySections = ['oferta', 'compra-final'].map(id => document.getElementById(id)).filter((el): el is HTMLElement => Boolean(el));
    const visibleBuy = new Set<Element>();
    const heroObs = new IntersectionObserver(([entry]) => setHeroVisible(entry.isIntersecting), {
      threshold: 0
    });
    const buyObs = new IntersectionObserver(entries => {
      entries.forEach(e => e.isIntersecting ? visibleBuy.add(e.target) : visibleBuy.delete(e.target));
      setBuyVisible(visibleBuy.size > 0);
    }, {
      threshold: 0.15
    });
    if (hero) heroObs.observe(hero);
    buySections.forEach(el => buyObs.observe(el));
    return () => {
      heroObs.disconnect();
      buyObs.disconnect();
    };
  }, []);
  const show = !heroVisible && !buyVisible && !dismissed;
  return <AnimatePresence data-id="element-418" data-mp="29b169ugqxy38">
      {show && <motion.div initial={{
      y: '100%',
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: '100%',
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-teal-soft bg-white/95 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur md:hidden" data-id="element-419" data-mp="24awps4fu93d0">
          <div className="flex items-center gap-3" data-id="element-420" data-mp="3png7r4q5pknc">
            <div className="shrink-0" data-id="element-421" data-mp="3por9kz01kibt">
              <p className="font-heading text-lg font-black leading-none text-pink" data-id="element-422" data-mp="1n1kl24cqnemg">{price}</p>
              <p className="mt-1 text-xs text-navy-soft" data-id="element-423" data-mp="1rrr8w1zfev3n">Pago único</p>
            </div>
            <CTAButton label="Quiero acceder" location="sticky-mobile" size="md" className="flex-1" data-id="element-424" data-mp="1e0mgnkye153c" />
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar barra de compra" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-navy-soft transition-colors duration-150 ease-out hover:bg-teal-soft" data-id="element-425" data-mp="1i27p8u3w2x7q">
              <XIcon className="h-5 w-5" data-id="element-426" data-mp="1wrx4ft8th1r0" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}